var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: _vm.tooltipText,
      expression: "tooltipText",
      modifiers: {
        "click": true
      }
    }],
    class: _vm.buttonClasses,
    on: {
      "click": _vm.handleCopy
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]), _c('SuccessPopup', {
    attrs: {
      "show": _vm.showSuccessPopup,
      "message": _vm.successMessage
    },
    on: {
      "close": function close($event) {
        _vm.showSuccessPopup = false;
      }
    }
  }), _c('ErrorPopup', {
    attrs: {
      "show": _vm.showErrorPopup,
      "title": "複製失敗！",
      "description": _vm.errorMessage
    },
    on: {
      "close": function close($event) {
        _vm.showErrorPopup = false;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }